import { useTheme } from "@emotion/react";
import { CardContent, Typography, Box, Paper, alpha } from "@mui/material";

import useStyles from "./styles";
import dayjs from "dayjs";
const CommentsSection = ({ comments = [] }) => {
  const theme = useTheme();

  const styles = useStyles(theme);
  return (
    <Box sx={{ height: "100%" }}>
      <CardContent sx={styles.containerComponent}>
        <Box sx={styles.containerTitle}>
          <Typography variant="body2" color="text.secondary">
            Últimos {comments.length} comentários
          </Typography>
        </Box>
        <Box variant="outlined" sx={styles.boxColor}>
          <Box variant="outlined" sx={styles.boxAuto}>
            <Box sx={styles.boxItens}>
              {comments?.map((comment, index) => (
                <Paper variant="outlined" key={index} sx={styles.paper}>
                  <Box sx={styles.boxComments}>
                    <Typography variant="caption" color="text.secondary">
                      {dayjs(comment?.date)?.format("DD/MM/YY")}
                    </Typography>
                  </Box>
                  <Typography variant="body2" sx={{ lineHeight: 1 }}>
                    {comment?.text}
                  </Typography>
                </Paper>
              ))}
            </Box>
          </Box>
        </Box>
      </CardContent>
    </Box>
  );
};

export default CommentsSection;
